import React from 'react'

function FindDataCardIcon() {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M120 60.0089C120 93.1483 93.1306 120 59.9911 120C26.8517 120 0 93.1306 0 60.0089C0 26.8871 26.8694 0 60.0089 0C93.1483 0 120.018 26.8694 120.018 60.0089H120Z"
        className="fill"
        fill="#4A4A4A"
        fillRule="nonzero"
      />
      <path
        d="M97.169 26.4089H22.7778C20.8118 26.4089 19.2354 27.9853 19.2354 29.9514V84.8591C19.2354 86.8075 20.8118 88.4016 22.7778 88.4016H97.169C99.1173 88.4016 100.711 86.8075 100.711 84.8591V29.9514C100.711 27.9853 99.1173 26.4089 97.169 26.4089ZM93.6266 81.3167H26.3203V33.4938H93.6266V81.3167Z"
        fill="white"
      />
      <path
        d="M68.8295 97.2575V91.9438H51.1173V97.2575H42.1727V104.342H78.1461V97.2575H68.8295Z"
        fill="white"
      />
      <path
        d="M71.6635 59.7078L48.248 59.7432L59.8672 41.9602L71.6635 59.7078Z"
        fill="white"
      />
      <path
        d="M85.0885 62.8075C85.0885 68.1566 80.7313 72.5138 75.3645 72.5138C74.7092 72.5138 74.0715 72.4429 73.4516 72.3189C73.1682 72.2658 72.9025 72.1595 72.6191 72.0709C72.3003 71.9824 71.9815 71.9115 71.6804 71.7876C71.2907 71.6281 70.9188 71.3979 70.5468 71.1853C70.3874 71.0968 70.228 71.0436 70.0863 70.9374C69.6258 70.6363 69.2007 70.2997 68.7933 69.9278C68.7579 69.8924 68.7224 69.8569 68.6693 69.8215C68.2442 69.4141 67.8368 68.9536 67.4826 68.4754C67.4826 68.4577 67.4826 68.44 67.4472 68.4222C67.2878 68.192 67.1461 67.9617 67.0044 67.7138C66.8627 67.4658 66.721 67.2178 66.6147 66.9698C66.597 66.9521 66.5793 66.9344 66.5793 66.9167C66.5793 66.8813 66.5439 66.8459 66.5261 66.8104C66.4553 66.6333 66.3844 66.4562 66.3136 66.2791C66.2605 66.1728 66.2073 66.0488 66.1719 65.9248C66.101 65.6769 66.0302 65.4289 65.9593 65.1809C65.8177 64.5787 65.7291 63.9411 65.6937 63.3034H78.2693L71.9106 53.7211C72.4066 53.544 72.9202 53.4023 73.4339 53.296C73.5402 53.296 73.6641 53.2429 73.7881 53.2252C74.3018 53.1366 74.8331 53.0835 75.3645 53.0835C80.7313 53.0835 85.0885 57.4407 85.0885 62.8075Z"
        fill="white"
      />
      <path
        d="M52.5351 63.3209V70.7777H34.5218V52.7644H48.5853L41.6775 63.3209H52.5351Z"
        fill="white"
      />
    </svg>
  )
}

export default FindDataCardIcon
